// @flow

import * as React from 'react';

import clsx from 'clsx';

import { Base } from '@gandi/ui';

import { PriceArea } from '../PriceArea';
import { BundlePrice } from '../PriceArea/BundlePrice';
import { useDomainBundle } from '../modules';

import styles from '../ProvidedDomainList/ProvidedRow.scss';

import { BundleDescription } from './BundleDescription';

export function DomainBundle(): React.MixedElement | null {
  const { loading, addBundle, removeBundle, allInTheCart } = useDomainBundle();

  return (
    <Base
      flex
      flexRow
      flexWrap
      className={clsx(styles.container, styles.bundle)}
    >
      <BundleDescription />
      <PriceArea
        loading={loading}
        addedToCart={allInTheCart}
        onClick={allInTheCart ? removeBundle : addBundle}
        isCartActionnable
      >
        <BundlePrice />
      </PriceArea>
    </Base>
  );
}
